import { Hero } from "../components/home/Hero";
import { ProductGateway } from "../components/home/ProductGateway";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <ProductGateway />
    </div>
  );
}
